import { useEffect } from "react";

export function usePrepopulatedFieldValidation(formMethods, fieldName, value) {
  useEffect(() => {
    if (!value || !formMethods || !fieldName) {
      return;
    }
    formMethods.setValueChange(fieldName, value);
    // do not add to dep array as the dependency on wvus-forms and watching this would cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
